import React, { useState, useCallback, useRef, useEffect } from 'react'
import parse from 'html-react-parser'
import { contextSearch } from '../../Api/search'

const ContextSearch = () => {
  const inputRef = useRef(null)
  const [showSearch, setShowSearch] = useState(false)
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  // useEffect(() => {
  //   inputRef?.current?.focus()
  //   document.addEventListener('keydown', (event) => {
  //     if (event.ctrlKey && event.key.toUpperCase() === 'K') {
  //       setShowSearch(true)
  //     }
  //     if (event.key.toUpperCase() === 'ESCAPE') {
  //       setShowSearch(false)
  //       setSearch('')
  //     }
  //   })
  //   return () => document.removeEventListener('keydown', () => {})
  // }, [showSearch, setShowSearch, inputRef])

  const contextSearchHandler = useCallback(async () => {
    if (search.trim()) {
      const apiResponse = await contextSearch(search)
      if (apiResponse) {
        const regEx = new RegExp(search, 'gi')
        let tempData = []
        apiResponse.forEach((item) => {
          let summary = item.summary.replace(regEx, '<strong>$&</strong>')
          let startTimeArray = new Date(item.start.dateTime)
            .toString()
            .split(' ')
          let endTimeArray = new Date(item.end.dateTime).toString().split(' ')
          let startTime = startTimeArray[4].split(':')
          let endTime = endTimeArray[4].split(':')
          let date = `${startTimeArray[1]} ${
            startTimeArray[2]
          },'${startTimeArray[3].substring(startTimeArray[3].length - 2)}`
          let attendees = item.attendees
            .map((el) => el.email.replace(regEx, '<strong>$&</strong>'))
            .join(', ')
          let searchData = [],
            extraNotes = 0
          if (item.searchData?.trim()) {
            searchData = item.searchData
              .split('\n')
              .filter(
                (str) =>
                  str?.trim() &&
                  str?.toLowerCase().includes(search.trim().toLocaleLowerCase())
              )
              .map((str) => str.replace(regEx, '<strong>$&</strong>'))
          }

          if (searchData.length > 3) {
            extraNotes = searchData.length - 3
            searchData = searchData.slice(0, 3)
          }
          tempData.push({
            summary: summary,
            time: `${date} ${startTime[0] + ':' + startTime[1]}-${
              endTime[0] + ':' + endTime[1]
            } ${
              parseInt(startTime[0]) * 60 + parseInt(startTime[1]) < 360
                ? 'AM'
                : 'PM'
            }`,
            attendees: attendees,
            eventId: item.id,
            isPrivate: item.isPrivate,
            notes: searchData,
            extraNotes: extraNotes,
          })
        })
        setData([...tempData])
      } else {
        setData([])
      }
    } else {
      setData([])
    }
  }, [search, setData])

  useEffect(() => {
    const getData = setTimeout(() => {
      contextSearchHandler()
    }, 1000)
    return () => clearTimeout(getData)
  }, [search, contextSearchHandler])
  const openExtensionHandler = useCallback((id, privateN) => {
    let tab = 'live'
    if (privateN && privateN === true) {
      tab = 'private'
    } else if (privateN === false) {
      tab = 'shared'
    }
    window.postMessage(
      {
        type: 'open-url',
        eventId: id,
        tab: tab,
      },
      '*'
    )
    setSearch('')
    setShowSearch(false)
  }, [])
  return (
    <div className={showSearch ? 'context-search active' : 'context-search'}>
      <div className='context-search-wrapper'>
        <input
          value={search}
          ref={inputRef}
          onChange={(event) => setSearch(event.target.value)}
          placeholder='Search my information...'
        />
        {data?.length > 0 && (
          <ul>
            {data.map((item) => (
              <li key={item.eventId}>
                <button
                  onClick={() =>
                    openExtensionHandler(item.eventId, item.isPrivate)
                  }
                >
                  {parse(item.summary)} 📅 {item.time} 👥
                  {parse(item.attendees)}
                </button>
                {item.notes?.length > 0 && (
                  <h6>{item.isPrivate ? 'Private' : 'Shared'}</h6>
                )}
                {item.notes?.length > 0 &&
                  item.notes.map((note) => <p key={note}>{parse(note)}</p>)}
                {item.extraNotes > 0 && <span>+ {item.extraNotes}</span>}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default ContextSearch
